;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import {
	CLIENT_INVALIDATION_PATH,
	CLIENT_INVALIDATION_SEARCH_PARAM,
} from "@/lib/client-invalidation/catalog";

export function clientInvalidationSseUrl(workspaceId?: string): string {
	if (!workspaceId) {
		return CLIENT_INVALIDATION_PATH.sse;
	}

	const searchParams = new URLSearchParams({
		[CLIENT_INVALIDATION_SEARCH_PARAM.workspaceId]: workspaceId,
	});
	return `${CLIENT_INVALIDATION_PATH.sse}?${searchParams.toString()}`;
}
